(function() {

  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  Coop.Modules.mobileTabs = {
    init: function() {
      this.$tabs = $('.tabs-nav a');
      this.bindEvents();
    },
    bindEvents: function() {
      this.$tabs
        .off('click.mobileTabs')
        .on('click.mobileTabs', function (e) {
          var state = window.history.state;

          e.preventDefault();

          state.view = $(this).attr('href');

          window.history.pushState(state, state.title, state.url);
        });
    },
    activateTab: function(tabId) {
      $('body').removeClass('map-view list-view').addClass(tabId.replace('#', '') + '-view');
      this.$tabs.removeClass('active');
      $('.tabs-nav [href="' + tabId + '"]').addClass('active');

      Coop.Modules.AppHeight.fitLayout();

      if (tabId === '#map') {
        var search = locationSearch.currentSearch,
            results = locationsMap.getMarkersFromList();

        locationsMap.clearMap();
        locationsMap.renderSearchLocationMarker(search.coords.latitude, search.coords.longitude, !!Coop.Modules.Geolocator.currentLocation);
        locationsMap.populateMap(results);
      }
    }
  };
}());
